import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static targets = ['item']

  connect() {
    this.observeAsyncElement()
    window.addEventListener('hashchange', () => { this.handleHashChange() })
  }

  observeAsyncElement() {
    const hash = window.location.hash

    if (hash) {
      $(`${hash}`)[0].scrollIntoView()
    }

    this.handleHashChange()
  }

  handleHashChange() {
    this.highlightItem(
      this.itemTargets.find(li => this.hashFromHref(li.children[0].dataset.hrefHash) === window.location.hash)
    )
  }

  highlightItem(item) {
    if (!item) return

    this.itemTargets.forEach(target => target.classList.remove('border-solid', 'border-0', 'border-l-2', 'border-fn-tomato-500', 'pl-2'))

    item.classList.add('border-solid', 'border-0', 'border-l-2', 'border-fn-tomato-500', 'pl-2')
  }

  hashFromHref(href) {
    const url = new URL(`${window.location.origin}${href}`)

    return url.hash
  }

  replaceState(event) {
    const href = this.hashFromHref(event.target.dataset.hrefHash)

    window.location.replace(href)
    this.handleHashChange()
  }
}
